/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-10 14:49:27
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-15 14:38:18
 */
export default [
    {
    path: "configureList",
    name:  "CONFIGURE_LIST",
    meta: {
      title: "微信授权地址配置",
      icon: "",
      cache:'showCache',
      isNav: true,
    },
    component: () =>
      import("@/views/WechatConfiguration/configureList.vue"),
  },
    {
        path: "test",
        name:  "TEST",
        meta: {
            title: "海报图生成",
            icon: "",
            cache:'showCache',
            isNav: true,
        },
        component: () =>
            import("@/views/WechatConfiguration/Test.vue"),
    },
    {
        path: "info",
        name:  "INFO",
        meta: {
            title: "版本详情",
            icon: "",
            cache:'showCache',
            isNav: true,
        },
        component: () =>
            import("@/views/WechatConfiguration/editionInfo.vue"),
    },
];